module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.url !== undefined && _vm.url !== null && _vm.url !== false && _vm.url !== '') ? _c('div', {
    staticClass: "w5-preview-image-wrapper"
  }, [_c('img', {
    ref: "image",
    staticClass: "w5-view-field-preview-image",
    class: {
      'ready-image': _vm.imageReady, 'cursor-pointer-default': _vm.noPreview
    },
    attrs: {
      "src": _vm.currentUrl,
      "title": _vm._f("ftc")(_vm.text ? _vm.text : '')
    },
    on: {
      "click": _vm.showPreviewDialog
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideModalDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    style: ('width:' + _vm.modalWidth + 'px;'),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")(_vm.text ? _vm.text : '')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideModalDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    ref: "imageInDialog",
    style: ('width:' + _vm.imageWidth + 'px; height:' + _vm.imageHeight + 'px;')
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "w5-preview-in-dialog-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.title ? _vm.title : '')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.size ? '(' + _vm.size + ')' : '')))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-submit w5-file-uploader-load-button pull-right",
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download')))])])])])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3093b23a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/previewimg.vue
// module id = 547
// module chunks = 0